export default {
  social_video: {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET POTENTIAL',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 101,
                      label: "Lift to Impression (among total)",
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 110,
                      label:"Non-Users' Lift to Consideration",
                      maxValue: 0.8,
                      format: '%,1'
                    }
                    , {
                      metric: 112,
                      label:"Users' Lift to Consideration",
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Actions',
                    metrics: [
                      { metric: 102, isHeaderMetric: true, isCapitalized: true },
                      { metric: 103, isHeaderMetric: true },
                      { metric: 104, isHeaderMetric: true },
                      { metric: 105, isHeaderMetric: true },
                      { metric: 106, isHeaderMetric: true },
                      { metric: 107, isHeaderMetric: true },
                      { metric: 108, isHeaderMetric: true },
                      { metric: 109, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 115, isHeaderMetric: true },
                      { metric: 116, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 202, label: 'Category Connection' },
                      { metric: 122, label: 'Brand Connection' },
                      { metric: 130, label: 'Relevance' },
                      { metric: 138, label: 'Engagement' },
                      { metric: 146, label: 'Cognitive' },

                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 117,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 118,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  }



// WEBPACK FOOTER //
// ./src/app/configuration/Max/config/components/quickview/index.js